import axios from 'axios'

export default {
  namespaced: true,
  state: {
    employeeDoc: null,
    employeeDocGrid: [],
  },
  mutations: {
    setEmployeeDocGrid(state, payload) {
      state.employeeDocGrid = payload ? payload : []
    },
  },
  getters: {
    employeeDoc: (state) => state.employeeDoc,
    employeeDocGrid: (state) => state.employeeDocGrid,
  },
  actions: {
    onEmployeeDocGrid({ commit, rootState }, userId) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain + '/api/admin/employee/doc/grid?limit=0&filter[]=user_id:' + userId,
          method: 'GET',
        })
          .then((resp) => {
            commit('setEmployeeDocGrid', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onCreateEmployeeDoc({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/employee/doc',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onUpdateEmployeeDoc({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/employee/doc',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
